import { render, staticRenderFns } from "./OffAirSummary.vue?vue&type=template&id=cabeef4e"
import script from "./OffAirSummary.vue?vue&type=script&lang=js"
export * from "./OffAirSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports